import type { Component } from 'vue';
import type { ElementType } from '../model/form.types';
import {
  HeaderProperties,
  FixedTextProperties,
  TextInputProperties,
  ParagraphProperties,
  NumberInputProperties,
  RadioGroupProperties,
  DateInputProperties,
  EmailInputProperties,
  UrlInputProperties,
  DropdownProperties,
  CheckboxProperties,
  RegisterNumberInputProperties,
  IndexerTitleProperties,
  FillTitleProperties,
  CheckboxGroupDesignProperties,
  TitleDesignProperties,
  UniversalProperties,
} from '../ui/elements/properties';

export type PropertySection = 'config' | 'design' | 'extras';

interface ElementSectionConfig {
  sections: PropertySection[];
  configComponent: Component;
  designComponent?: Component;
  extrasComponent?: Component;
}

const ELEMENT_SECTION_CONFIG: Record<Exclude<ElementType, 'TABLE'>, ElementSectionConfig> = {
  HEADER: {
    sections: ['config'],
    configComponent: HeaderProperties,
  },
  FIXED_TEXT: {
    sections: ['config', 'design', 'extras'],
    configComponent: FixedTextProperties,
    extrasComponent: UniversalProperties,
  },
  TEXT_INPUT: {
    sections: ['config', 'design'],
    configComponent: TextInputProperties,
  },
  PARAGRAPH: {
    sections: ['config', 'design', 'extras'],
    configComponent: ParagraphProperties,
    extrasComponent: UniversalProperties,
  },
  NUMBER_INPUT: {
    sections: ['config', 'design', 'extras'],
    configComponent: NumberInputProperties,
    extrasComponent: UniversalProperties,
  },
  DATE_INPUT: {
    sections: ['config', 'design', 'extras'],
    configComponent: DateInputProperties,
    extrasComponent: UniversalProperties,
  },
  URL_INPUT: {
    sections: ['config', 'design', 'extras'],
    configComponent: UrlInputProperties,
    extrasComponent: UniversalProperties,
  },
  EMAIL_INPUT: {
    sections: ['config', 'design', 'extras'],
    configComponent: EmailInputProperties,
    extrasComponent: UniversalProperties,
  },
  REGISTER_NUMBER_INPUT: {
    sections: ['config', 'design', 'extras'],
    configComponent: RegisterNumberInputProperties,
    extrasComponent: UniversalProperties,
  },
  INDEXER_TITLE: {
    sections: ['config', 'design', 'extras'],
    configComponent: IndexerTitleProperties,
    designComponent: TitleDesignProperties,
    extrasComponent: UniversalProperties,
  },
  FILL_TITLE: {
    sections: ['config', 'design', 'extras'],
    configComponent: FillTitleProperties,
    designComponent: TitleDesignProperties,
    extrasComponent: UniversalProperties,
  },
  DROPDOWN: {
    sections: ['config', 'design', 'extras'],
    configComponent: DropdownProperties,
    extrasComponent: UniversalProperties,
  },
  RADIO_GROUP: {
    sections: ['config', 'design', 'extras'],
    configComponent: RadioGroupProperties,
    designComponent: CheckboxGroupDesignProperties,
    extrasComponent: UniversalProperties,
  },
  CHECKBOX: {
    sections: ['config', 'design', 'extras'],
    configComponent: CheckboxProperties,
    designComponent: CheckboxGroupDesignProperties,
    extrasComponent: UniversalProperties,
  },
  IMAGE: {
    sections: ['config', 'design'],
    configComponent: UniversalProperties,
  },
};

export const DESIGN_COMPONENT = UniversalProperties;

export function getElementSectionConfig(type: ElementType): ElementSectionConfig | null {
  if (type === 'TABLE') return null;
  return ELEMENT_SECTION_CONFIG[type] ?? null;
}

export function getElementSections(type: ElementType): PropertySection[] {
  const config = getElementSectionConfig(type);
  return config?.sections ?? [];
}
